import { useSelector, shallowEqual } from 'react-redux';
import { Profiler } from '@eti/utils';
import { breakpoints, Dialog, Stack } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { screenReaderOnly } from '../../common/utils/styles';
import { isSelected, getPrice } from '../utils/selection';
import SeatMap from './SeatMap';
import SeatMapProductCard from './SeatMapProductCard';
import { SEAT_MAP_DIALOG_ID } from '../constants/modal';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const seatMapDialogStyles = css`
  box-shadow: 0 0 10px rgb(0 0 0 / 20%);
  height: inherit;
  max-height: 100%;
  outline: none;
  position: absolute;

  > div {
    height: 100%;
  }

  & > div > div:nth-of-type(1) {
    display: none;
  }

  & > div > div:nth-of-type(2) {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    overflow: hidden;
    padding: 0;
  }

  @media (min-width: ${breakpoints._768}) {
    height: 90vh;
    inset: 20px;
    margin: auto;
    max-width: 48rem;
  }

  @media (min-width: ${breakpoints._970}) {
    max-width: ${breakpoints._1170};
  }

  @media (min-width: ${breakpoints._1170}) {
    width: ${breakpoints._1170};
  }
`;
const SeatMapProductModal = ({
  bounds,
  form,
  isPostBooking,
  isSeatMapModalOpen,
  order,
  seatMapCallback,
  setIsSeatMapModalOpen,
  travelers
}) => {
  const {
    t
  } = useTranslation();
  const isSeatMapSelected = useSelector(state => isSelected('seatMap', form)(state));
  const {
    price
  } = useSelector(state => getPrice('seatMap', form)(state), shallowEqual);
  const priceRaw = isSeatMapSelected ? price : 0;
  return /*#__PURE__*/_jsx(Stack, {
    "data-testid": "SeatMapNewLayout",
    children: /*#__PURE__*/_jsx(Profiler, {
      id: "TravelerDetails-SeatMap",
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(SeatMapProductCard, {
          bounds: bounds,
          form: form,
          isSeatMapModalOpen: isSeatMapModalOpen,
          isSelected: isSeatMapSelected,
          order: order,
          priceRaw: priceRaw,
          setIsSeatMapModalOpen: setIsSeatMapModalOpen
        }), /*#__PURE__*/_jsxs(Dialog, {
          className: seatMapDialogStyles,
          closeButtonAriaLabel: t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
          "data-testid": "seatMap-dialog",
          id: SEAT_MAP_DIALOG_ID,
          isOpen: isSeatMapModalOpen,
          title: "",
          children: [/*#__PURE__*/_jsx(SeatMap, {
            bounds: bounds,
            form: form,
            isPostBooking: isPostBooking,
            onCallback: seatMapCallback,
            onDismiss: () => setIsSeatMapModalOpen(false),
            shouldRenderInline: false,
            travelers: travelers
          }), /*#__PURE__*/_jsx("div", {
            "aria-live": "polite",
            className: screenReaderOnly,
            id: "live-region-all-passengers-seated"
            // oxlint-disable-next-line jsx-a11y/prefer-tag-over-role
            ,
            role: "region"
          })]
        })]
      })
    })
  });
};
export default SeatMapProductModal;
//# sourceMappingURL=SeatMapProductModal.js.map